import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
  `,
  selectingMethod: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 46px;
    padding-left: 24px;
    padding-right: 24px;
    justify-content: center;
    padding-bottom: 100px;
  `,
  actions: css`
    display: flex;
    flex-direction: row;
    gap: 46px;
    align-items: center;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
